import { Player } from '@loomhq/createhq/dist/video-player/api';
// import Hls from 'hls.js';
import playerjs from 'player.js';

import { DASH, M3U8 } from 'constants/mimes';
import * as loggerx from 'utilities/loggerx';

export const onDashError =
  (ctx: unknown) =>
  (playerError: { error?: unknown }): void => {
    const error = playerError.error || playerError;

    loggerx.error(Error('Shaka player error'), { error }, ctx);
  };

export const setupPlayerJsAdapter = (videoElement: HTMLVideoElement): void => {
  const adapter = playerjs.HTML5Adapter(videoElement);

  adapter.ready();
};

export const handleHlsJsBootUp = (player: Player): void => {
  // const onDuration = () => {
  //   player.mediaOff(['durationchange'], onDuration);
  //   player.mseTech.stopLoad();
  // };

  // // start the preloading dance
  // // preload just enough data to get the duration
  // player.mseTech.on(Hls.Events.MANIFEST_PARSED, () => {
  //   player.mseTech.startLoad(-1);
  // });
  // player.mediaOn(['durationchange'], onDuration);

  // load media on play
  player.mediaOn(['play'], function onPlayHls() {
    // player.mediaOff(['durationchange'], onDuration);
    player.mediaOff(['play'], onPlayHls);
    player.mseTech.startLoad(-1);
  });
};

export const destroyMseTech = async (player: Player): Promise<void> => {
  player.mux?.destroy?.();

  if (player.mime === DASH) {
    await player.mseTech.detach();
    player.mseTech = null;
  }

  if (player.mime === M3U8) {
    await player.mseTech.destroy();
    player.mseTech = null;
  }
};
